<mat-toolbar color="primary">
  <span>BNA</span>
</mat-toolbar>
<router-outlet />
